<template>
  <div>
    <h1 class="page-header">{{ $t('building.building') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px;"
              class="kh-font"
            />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td>
                {{ record.branch !== null ? record.branch.branch_name_en : '' }}
              </td>
              <td>{{ record.building_name }}</td>
              <td>
                {{ $store.getters.limitStringShow(record.address) }}
              </td>
              <td>
                {{ $store.getters.limitStringShow(record.bd_description) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  title="edit"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  title="delete"
                  class="text-danger"
                  @click.prevent="destroy(record.building_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'building',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: this.$t('building.branch'), style: 'width: 10%' },
        { name: this.$t('building.name'), style: 'width: 20%' },
        { name: this.$t('building.address') },
        { name: this.$t('building.description') },
        {
          name: this.$t('building.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('building', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.building.search
      },
      set(newVal) {
        this.$store.commit('building/SET_SEARCH', newVal)
        this.$store.commit('building/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('building/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/buildings/${data.building_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('building/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'building-create') {
      this.$store.commit('building/RESET_STATE')
    }
    next()
  }
}
</script>
